module.exports = __webpack_public_path__ + "static/media/share-desktop_dark.d6ebca00.svg";